<script setup>
</script>

<template>
  <section
    class="bg-white border-t border-b border-blue-100 p-6 dark:bg-gray-900 dark:border-gray-900 dark:text-white"
  >
    <base-level>
      <h2 class="text-2xl font-semibold leading-tight">
        <slot />
      </h2>
    </base-level>
  </section>
</template>
